import ShowcaseDtcCustomCta from '@zillow/custom-dtc-cta';
import DtsPropertyBlock from '@zillow/custom-dts-block';
import DtsCustomCta from '@zillow/custom-dts-cta';
import { AgentSearchBlock, AmortizationBlock, CashOutRefinanceCalculatorBlock, ClosingCostCalculatorBlock, DownPaymentCalculatorBlock, DTICalculatorBlock, FHACalculatorBlock, FSBOPropertySearchBlock, HelocCalculatorBlock, HomeSaleProceedsCalculatorBlock, HubspotEmbedBlock, HubspotFormBlock, LoanComparisonBlock, MortgageCalculatorBlock, MortgageRateTrendsBlock, MortgageRatesSummaryBlock, ProratedRentCalculatorBlock, PropertyReportTransparencyBlock, RentAffordabilityCalculatorBlock, RentalRoiCalculatorBlock, RiddleEmbedBlock, VALoanCalculatorBlock, MortgageQuestionnareBlock, RefinanceCalculatorBlock } from '@zillow/zrs-cms';
import ZHLRateCards from '../blocks/RateCards/RateCards.js';
import RateSummaryBlock from '../blocks/RateSummary/RateSummary.js';
import { frontierBlocks } from '../frontier/init.js';
import AffordabilityCalculator from '../blocks/AffordabilityCalculator/AffordabilityCalculatorBlock.js';
import AffordabilityCalculatorV2 from '../blocks/AffordabilityCalculatorV2/AffordabilityCalculatorV2.js';
import ApexField from '../blocks/ApexField/ApexField.js';
import ApexFields from '../blocks/ApexFields/ApexFields.js';
import ApexForm from '../blocks/ApexForm/ApexForm.js';
import ApexSubmit from '../blocks/ApexSubmit/ApexSubmit.js';
import ApexSuccess from '../blocks/ApexSuccess/ApexSuccess.js';
import Button from '../blocks/Button/Button.js';
import ButtonGroup from '../blocks/ButtonGroup/ButtonGroup.js';
import Card from '../blocks/Card/Card.js';
import Carousel from '../blocks/CarouselItem/Carousel.js';
import CarouselV2 from '../blocks/Carousel/Carousel.js';
import Divider from '../blocks/Divider/Divider.js';
import Embed from '../blocks/Embed/Embed.js';
import FAQ from '../blocks/FAQ/FAQ.js';
import FAQItem from '../blocks/FAQItem/FAQItem.js';
import GridContent from '../blocks/GridContent/GridContent.js';
import GridLayout from '../blocks/GridLayout/GridLayout.js';
import Group from '../blocks/Group/Group.js';
import Heading from '../blocks/Heading/Heading.js';
import HmimhwPropertySearch from '../blocks/HmimhwPropertySearch/HmimhwPropertySearch.js';
import Image from '../blocks/Image/Image.js';
import List from '../blocks/List/List.js';
import ListItem from '../blocks/ListItem/ListItem.js';
import MediaObject from '../blocks/MediaObject/MediaObject.js';
import MediaStepper from '../blocks/MediaStepper/MediaStepperBlock.js';
import ModalDialog from '../blocks/ModalDialog/ModalDialog.js';
import MilitaryInstallationHomeSearch from '../blocks/MilitaryInstallationHomeSearch/MilitaryInstallationHomeSearch.js';
import MilitaryRentCalculator from '../blocks/MilitaryRentCalculator/MilitaryRentCalculator.js';
import MortgageRatesTable from '../blocks/MortgageRatesTable/MortgageRatesTable.js';
import Paragraph from '../blocks/Paragraph/Paragraph.js';
import Picture from '../blocks/Picture/Picture.js';
import Posts from '../blocks/Posts/Posts.js';
import PropertySearch from '../blocks/PropertySearch/PropertySearch.js';
import PropertyTaxCalculator from '../blocks/PropertyTaxCalculator/PropertyTaxCalculator.js';
import Quote from '../blocks/Quote/Quote.js';
import SEOFooter from '../blocks/SEOFooter/SEOFooter.js';
import SimonField from '../blocks/SimonField/SimonField.js';
import SimonFields from '../blocks/SimonFields/SimonFields.js';
import SimonForm from '../blocks/SimonForm/SimonForm.js';
import SimonSuccess from '../blocks/SimonSuccess/SimonSuccess.js';
import Spacer from '../blocks/Spacer/Spacer.js';
import Table from '../blocks/Table/Table.js';
import Tabs from '../blocks/Tabs/Tabs.js';
import TaxComparisonTable from '../blocks/TaxComparisonTable/TaxComparisonTable.js';
import Upsell from '../blocks/Upsell/Upsell.js';
import Video from '../blocks/Video/Video.js';
import Vimeo from '../blocks/Vimeo/Vimeo.js';
import WPBlock from '../blocks/WPBlock/WPBlock.js';
import WPList from '../blocks/WPList/index.js';
import Youtube from '../blocks/Youtube/Youtube.js';
import ZOAddressSearch from '../blocks/ZOAddressSearch/ZOAddressSearch.js';

/* eslint-disable import/order */

// !!! IMPORTANT !!!
// This is where you add your components to onboard with CMS
// Add your component block as an import above, then add it to the CMS_BLOCKS
// array below. If you need help, feel free to reach out to the CMS team
// For more information, reference the onboarding guide here: https://zillowgroup.atlassian.net/wiki/spaces/CMS/pages/798524524/CMS+Block+Onboarding
var CMS_BLOCKS = [AgentSearchBlock, AmortizationBlock, CashOutRefinanceCalculatorBlock, ClosingCostCalculatorBlock, DownPaymentCalculatorBlock, DTICalculatorBlock, DtsCustomCta, DtsPropertyBlock, FHACalculatorBlock, FSBOPropertySearchBlock, HelocCalculatorBlock, HomeSaleProceedsCalculatorBlock, HubspotEmbedBlock, HubspotFormBlock, LoanComparisonBlock, MortgageCalculatorBlock, MortgageRateTrendsBlock, MortgageRatesSummaryBlock, ProratedRentCalculatorBlock, PropertyReportTransparencyBlock, RentAffordabilityCalculatorBlock, RentalRoiCalculatorBlock, RiddleEmbedBlock, ShowcaseDtcCustomCta, VALoanCalculatorBlock, MortgageQuestionnareBlock, RefinanceCalculatorBlock, ZHLRateCards, RateSummaryBlock];
var BLOCK_MAPPING = Object.assign({
  'constellation/affordability-calculator': AffordabilityCalculator,
  'constellation/affordability-calculator-v2': AffordabilityCalculatorV2,
  'constellation/apex-field': ApexField,
  'constellation/apex-fields': ApexFields,
  'constellation/apex-form': ApexForm,
  'constellation/apex-submit': ApexSubmit,
  'constellation/apex-success': ApexSuccess,
  'constellation/button': Button,
  'constellation/button-group': ButtonGroup,
  'constellation/card': Card,
  'constellation/carousel': Carousel,
  'constellation/carousel-v2': CarouselV2,
  'constellation/divider': Divider,
  'constellation/embed': Embed,
  'constellation/faq': FAQ,
  'constellation/faq-item': FAQItem,
  'constellation/grid-content': GridContent,
  'constellation/grid-layout': GridLayout,
  'constellation/group': Group,
  'constellation/heading': Heading,
  'constellation/hmimhw-property-search': HmimhwPropertySearch,
  'constellation/image': Image,
  'constellation/list': List,
  'constellation/list-item': ListItem,
  'constellation/media-object': MediaObject,
  'constellation/media-stepper': MediaStepper,
  'constellation/modal-dialog': ModalDialog,
  'constellation/military-installation-home-search': MilitaryInstallationHomeSearch,
  'constellation/military-rent-calculator': MilitaryRentCalculator,
  'constellation/mortgage-rates-table': MortgageRatesTable,
  'constellation/paragraph': Paragraph,
  'constellation/picture': Picture,
  'constellation/posts': Posts,
  // TODO: Posts can't be dynamic because of getBlocksData when we updated to next 13 we can fix this.
  'constellation/property-search': PropertySearch,
  'constellation/property-tax-calculator': PropertyTaxCalculator,
  'constellation/quote': Quote,
  'constellation/seo-footer': SEOFooter,
  'constellation/simon-field': SimonField,
  'constellation/simon-fields': SimonFields,
  'constellation/simon-form': SimonForm,
  'constellation/simon-success': SimonSuccess,
  'constellation/spacer': Spacer,
  'constellation/table': Table,
  'constellation/tabs': Tabs,
  'constellation/tax-comparison-table': TaxComparisonTable,
  'constellation/upsell': Upsell,
  'constellation/video': Video,
  'constellation/vimeo': Vimeo,
  'constellation/youtube': Youtube,
  'constellation/zo-address-search': ZOAddressSearch,
  'core/block': WPBlock,
  'core/list': WPList
}, frontierBlocks, CMS_BLOCKS.reduce(function (obj, block, index) {
  var _block$metadata;
  if (!block) {
    throw new Error("No block found for index " + index);
  }
  if ((_block$metadata = block.metadata) !== null && _block$metadata !== void 0 && _block$metadata.name) {
    obj[block.metadata.name] = block;
  } else {
    console.error('No name found for block', block, 'Check if "name" is set in the block metadata');
  }
  return obj;
}, {}));
var BLOCK_MAPPING$1 = BLOCK_MAPPING;

export { BLOCK_MAPPING, BLOCK_MAPPING$1 as default };
